enum RobotVersion {
  K900 = "K900",
  K700 = "K700",
}

export const getRobotWidthFromVersion = (version: RobotVersion) => {
  switch (version) {
    case RobotVersion.K700:
      return 0.7; // needed to get width approximately correct
    default:
      return 0.8;
  }
};

export default RobotVersion;
